import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-bold font-heading tracking-tight">
                黑料大全
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              全网热门黑料汇总平台，涵盖娱乐圈、网红、明星等各类爆料信息，持续更新，助你第一时间掌握热点黑料动态。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              <a href="#categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@heiliao.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-base"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 黑料大全 HeiliaoDaqoan.com - 版权所有
          </p>
          <p className="text-xs text-secondary-400">
            本站内容来源于网络，如有侵权请联系删除
          </p>
        </div>
      </div>
    </footer>
  );
}